const normalize=(value:string)=>value.normalize('NFKC').toLowerCase().replace(/[^\p{L}\p{N}]/gu,'');
export function focusedSourceText(text:string,fields:string[]):string {
  const selected=new Set(fields.filter(field=>field.length>0 && field.length<40));
  const lines=text.split('\n').filter(line=>selected.has(line.split(/[：:]/u,1)[0]?.trim() || ''));
  return lines.length?lines.join('\n'):text;
}
export function sourceBlockMatches(block:string,quote:string):boolean {
  const haystack=normalize(block);
  if(haystack.length<8)return false;
  return quote.split('\n').flatMap(line=>{
    const colon=line.search(/[：:]/u);return (colon>=0?line.slice(colon+1):line).split(/[。；;\n]/u);
  }).some(sentence=>{
    const needle=normalize(sentence);
    if(needle.length<8)return false;
    if(haystack.includes(needle) || needle.includes(haystack))return true;
    for(let i=0;i+16<=needle.length;i+=8)if(haystack.includes(needle.slice(i,i+16)))return true;
    return false;
  });
}
